<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑` : '新增'" width="1200" @on-cancel="modalCancel">
    <k-form-design ref="kfd" toolbarsTop :hideModel="true" title="表单配置" @save="handleSave" showToolbarsText />
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
    </div>
  </Modal>
</template>

<script>
  import 'k-form-design/lib/k-form-design.css'
  // 与 main.js 注册的 packages 同源，避免 mini.common 另一份 nodeSchema 导致裁剪不生效
  import * as kFormDesignUtils from 'k-form-design/packages/utils'
  import { Message } from 'view-design'
  import { resolveNodeSchema, configureActivityFormSchema } from '@/libs/k-form-node-schema'

  const nodeSchema = resolveNodeSchema(kFormDesignUtils)
  if (!configureActivityFormSchema(nodeSchema)) {
    Message.warning('表单组件配置异常，已使用默认组件列表')
  }
  export default {
    name: 'add-card',
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
      registration_form: {
        type: [Array],
        default: () => {
          return []
        },
      },
      registration_form_json: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    methods: {
      // 回显json
      getDetail() {
        if (this.registration_form) {
          this.$refs.kfd.handleSetData({
            list: this.registration_form,
            config: {
              layout: 'horizontal',
              labelCol: {
                span: 4,
              },
              wrapperCol: {
                span: 18,
              },
              hideRequiredMark: false,
              customStyle: '',
            },
          })
        }
      },
      // 保存
      handleSave(e) {
        this.$emit('on-success', {
          registration_form_json: e,
          registration_form: JSON.parse(e).list,
        })
        this.modalCancel()
      },
      // 提交
      modalConfirm() {},
      modalCancel() {
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      value(val) {
        if (val) {
          this.getDetail()
        }
      },
    },
  }
</script>

<style scoped lang="less">
  .form-content {
    display: flex;
    justify-content: left;

    .tips {
      margin: 0 10px;
    }
  }
</style>
